import * as actionTypes from "../actions/actionTypes";
import {
  getMyCoursesFunc,
  setMyCoursesLoader,
  myCoursesPageIncrement,
  clearMyCourses,
} from "../utility/courseFunctions";

const initialState = {
  courses: [],
  total: 0,
  isLoading: true,
  page: 1,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_MY_COURSES:
      return getMyCoursesFunc(state, action.courses, action.total);

    case actionTypes.SET_MY_COURSES_LOADER:
      return setMyCoursesLoader(state, action.loaderValue);

    case actionTypes.MY_COURSES_PAGE_INCREMENT:
      return myCoursesPageIncrement(state);

    case actionTypes.CLEAR_MY_COURSES:
      return clearMyCourses();

    default:
      return state;
  }
};

export default reducer; 